export const ADD_TRAVELERS = "Add travelers";
export const ADD_CONTACT_INFO = "Add contact information";
export const APPLY_REWARDS = "Apply rewards";
export const CONFIRM_AND_BOOK = "Confirm and book";
